import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.push.js";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { trackCxFoundationsOrderListPageBrandOrderClick } from "@faire/web-api/events/cxFoundations/click/orderListPageBrandOrder";
import home from "@faire/web-api/routes/support";
import { logWarning } from "@faire/web/common/logging";
import { useHistory } from "react-router-dom";
import { StepPage, selfServePageToStepAndRoute, selfServePageToStepAndRouteWithoutOrderSelection } from "../view/step";
import { useNavigationStore } from "./NavigationContext";
import { useSelfServeContextStore } from "./SelfServeContext";
import { useCurrentNodeHasMoreLevels } from "./useCurrentNodeHasMoreLevels";
import { useIssueType } from "./useIssueType";
export var useNavigation = function useNavigation() {
  var _useNavigationStore = useNavigationStore(["currentPage"]),
    _useNavigationStore2 = _slicedToArray(_useNavigationStore, 2),
    currentPage = _useNavigationStore2[0].currentPage,
    setNavigationStore = _useNavigationStore2[1];
  var _useSelfServeContextS = useSelfServeContextStore(["brandOrders", "selectedBrandOrder"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    _useSelfServeContextS3 = _useSelfServeContextS2[0],
    brandOrders = _useSelfServeContextS3.brandOrders,
    selectedBrandOrder = _useSelfServeContextS3.selectedBrandOrder;
  var _useCurrentNodeHasMor = useCurrentNodeHasMoreLevels(1),
    hasMoreIssueLevels = _useCurrentNodeHasMor.hasMoreIssueLevels;
  var _useCurrentNodeHasMor2 = useCurrentNodeHasMoreLevels(),
    latestNodeHasMoreLevels = _useCurrentNodeHasMor2.hasMoreIssueLevels;
  var history = useHistory();
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var goToPreviousStep = function goToPreviousStep() {
    if (!currentPage) {
      logWarningUnexpectedPath(currentPage);
      return;
    }
    switch (currentPage) {
      case StepPage.TOPIC_SELECTION:
        history.push(home());
        break;
      case StepPage.ORDER_SELECTION:
        navigate(StepPage.TOPIC_SELECTION);
        break;
      case StepPage.TELL_US_MORE:
        goToPreviousStepFromTellUsMoreStep();
        break;
      case StepPage.ANSWER:
        goToPreviousStepFromAnswerStep();
        break;
      case StepPage.EMAIL_FORM:
      case StepPage.PHONE_FORM:
        navigate(StepPage.ANSWER);
        break;
      case StepPage.EMAIL_SUBMISSION_CONFIRMATION:
        navigate(StepPage.EMAIL_FORM);
        break;
      case StepPage.PHONE_SUBMISSION_CONFIRMATION:
        navigate(StepPage.PHONE_FORM);
        break;
      default:
        logWarningUnexpectedPath(history.location.pathname);
    }
  };
  var goToNextStep = function goToNextStep() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      brandOrder = _ref.brandOrder,
      supportType = _ref.supportType,
      skipOrderSelection = _ref.skipOrderSelection;
    if (!currentPage) {
      logWarningUnexpectedPath(currentPage);
      return;
    }
    switch (currentPage) {
      case StepPage.ISSUE_SEARCH:
        goToNextStepFromIssueSearchStep();
        break;
      case StepPage.TOPIC_SELECTION:
        goToNextStepFromTopicSelectionStep(skipOrderSelection);
        break;
      case StepPage.ORDER_SELECTION:
        goToNextStepFromOrderSelectStep(brandOrder);
        break;
      case StepPage.TELL_US_MORE:
        navigate(StepPage.ANSWER);
        break;
      case StepPage.ANSWER:
        goToNextStepFromAnswerStep(supportType);
        break;
      case StepPage.EMAIL_FORM:
        navigate(StepPage.EMAIL_SUBMISSION_CONFIRMATION);
        break;
      case StepPage.PHONE_FORM:
        navigate(StepPage.PHONE_SUBMISSION_CONFIRMATION);
        break;
      default:
        logWarningUnexpectedPath(history.location.pathname);
    }
  };
  var goToNextStepFromAnswerStep = function goToNextStepFromAnswerStep(supportType) {
    if (supportType === "email") {
      navigate(StepPage.EMAIL_FORM);
    } else if (supportType === "phone") {
      navigate(StepPage.PHONE_FORM);
    }
  };
  var goToNextStepFromTopicSelectionStep = function goToNextStepFromTopicSelectionStep(skipOrderSelection) {
    if (brandOrders && brandOrders.length > 0 && !selectedBrandOrder && !skipOrderSelection) {
      navigate(StepPage.ORDER_SELECTION);
    } else {
      navigateAheadToStep3or4();
    }
  };
  var goToNextStepFromIssueSearchStep = function goToNextStepFromIssueSearchStep() {
    if (latestNodeHasMoreLevels) {
      navigate(StepPage.TELL_US_MORE);
    } else {
      navigate(StepPage.ANSWER);
    }
  };
  var goToNextStepFromOrderSelectStep = function goToNextStepFromOrderSelectStep(brandOrder) {
    var _brandOrder$brand_ord, _brandOrder$brand_ord2;
    var retailerOrBrandToken = getRetailerOrBrandToken();
    trackCxFoundationsOrderListPageBrandOrderClick((_brandOrder$brand_ord = brandOrder === null || brandOrder === void 0 ? void 0 : (_brandOrder$brand_ord2 = brandOrder.brand_order) === null || _brandOrder$brand_ord2 === void 0 ? void 0 : _brandOrder$brand_ord2.token) !== null && _brandOrder$brand_ord !== void 0 ? _brandOrder$brand_ord : "", retailerOrBrandToken, issueType);
    navigateAheadToStep3or4();
  };
  var goToPreviousStepFromTellUsMoreStep = function goToPreviousStepFromTellUsMoreStep() {
    navigateBackToStep2or1();
  };
  var goToPreviousStepFromAnswerStep = function goToPreviousStepFromAnswerStep() {
    if (hasMoreIssueLevels) {
      navigate(StepPage.TELL_US_MORE);
    } else {
      navigateBackToStep2or1();
    }
  };
  var navigateAheadToStep3or4 = function navigateAheadToStep3or4() {
    if (hasMoreIssueLevels) {
      navigate(StepPage.TELL_US_MORE);
    } else {
      navigate(StepPage.ANSWER);
    }
  };
  var navigateBackToStep2or1 = function navigateBackToStep2or1() {
    if (brandOrders && brandOrders.length > 0) {
      navigate(StepPage.ORDER_SELECTION);
    } else {
      navigate(StepPage.TOPIC_SELECTION);
    }
  };
  var navigate = function navigate(page) {
    if (brandOrders && brandOrders.length > 0) {
      setNavigationStore({
        currentStep: selfServePageToStepAndRoute[page].step,
        currentPage: page
      });
      history.push(selfServePageToStepAndRoute[page].route, {
        from: {
          page: currentPage
        }
      });
    } else {
      setNavigationStore({
        currentStep: selfServePageToStepAndRouteWithoutOrderSelection[page].step,
        currentPage: page
      });
      history.push(selfServePageToStepAndRouteWithoutOrderSelection[page].route, {
        from: {
          page: currentPage
        }
      });
    }
  };
  return {
    goToPreviousStep: goToPreviousStep,
    goToNextStep: goToNextStep
  };
};
var logWarningUnexpectedPath = function logWarningUnexpectedPath(path) {
  logWarning("NavigationStore.goToPreviousStep invoked from unexpected path causing step to be undefined", {
    data: {
      path: path
    }
  });
};